import React, { Component, Fragment } from "react";
import { Route } from "react-router";
import { useNetwork } from "./context/NetworkProvider";
import PageNotAccessibleComponent from "./components/Shared/PageNotAccessibleComponent";

import { Layout } from "./components/Layout";
import { AuthorisedLayout } from "./components/AuthorisedLayout";
import { ForgotPasswordComponent } from "./components/ForgotPasswordComponent";
import { RegisterComponent } from "./components/RegisterComponent";
import { LoginComponent } from "./components/LoginComponent";
import { DashboardComponent } from "./components/dashboard/DashboardComponent";
import { AirportComponent } from "./components/airport/AirportComponent";
import { ResetPasswordComponent } from "./components/ResetPasswordComponent";
import HotelsComponent from "./components/hotels/HotelsComponent";
import { ServiceProviderComponent } from "./components/serviceProvider/ServiceProviderComponent";
import { ReservationsComponent } from "./components/reservations/ReservationsComponent";
import { DispatchComponent } from "./components/reservations/DispatchComponent";
import { NotificationComponent } from "./components/notification/NotificationComponent";
import { TrackingComponent } from "./components/tracking/TrackingComponent";
import { CrewMembersComponent } from "./components/crewmembers/CrewMembersComponent";
import { UserComponent } from "./components/user/UserComponent";
import { RatingComponent } from "./components/rating/RatingComponent";
import { FeedbackComponent } from "./components/feedback/FeedbackComponent";
import { ReimburseTransport } from "./components/cancellation/ReimburseTransport";
import { UnApprovedApprovedRidesComponent } from "./components/billing/UnApprovedApprovedRidesComponent";
import { TransportComponent } from "./components/transportDepartment/TransportComponent";
import { InvoiceComponent } from "./components/invoice/InvoiceComponent";
import HotelTransferContractComponent from "./components/transporthotelconfiguration/HotelTransferContractComponent";
import { TransportHotelConfigurationComponent } from "./components/transporthotelconfiguration/TransportHotelConfigurationComponent";
import { ScheduleDashBoardComponent } from "./components/scheduleDashBoard/ScheduleDashBoardComponent";
import { EmailConfigurationComponent } from "./components/emailconfiguration/EmailConfigurationComponent";
import { CancelHotelComponent } from "./components/report/CancelHotelComponent";
import { StayHotelComponent } from "./components/report/StayHotelComponent";
import { HotelBookingComponent } from "./components/hotelbooking/HotelBookingComponent";
import { ChildBookingDataComponent } from "./components/hotelbooking/ChildBookingDataComponent";
import { CrewTypeTransportConfigurationComponent } from "./components/CrewTypeTransportConfiguration/CrewTypeTransportConfigurationComponent";
import ActivityDutyLocationTransferComponent from "./components/CrewTypeTransportConfiguration/ActivityDutyLocationTransferComponent";
import { HotelBookingPriority } from "./components/hotelbookingpriority/HotelBookingPriority";
import { AirportGeofenceReportComponent } from "./components/report/AirportGeofenceReportComponent";
import ActivityRawDataComponent from "./components/report/ActivityRawDataComponent";
import { CrewAddressComponent } from "./components/crewmembers/CrewAddressComponent";
import { FeedbackCommentComponent } from "./components/feedback/FeedbackCommentComponent";
import CrewActivityComponent from "./components/crewActivity/CrewActivityComponent";
import NonFlyActivityLocationComponent from "./components/crewActivity/NonFlyActivityLocationComponent";
import NonFlyTransportMatrixComponent from "./components/crewActivity/NonFlyTransportMatrixComponent";
import CrewActivityCodeComponent from "./components/crewActivity/CrewActivityCodeComponent";
import AirportHotelLocationTransportMatrixComponent from "./components/transporthotelconfiguration/AirportHotelLocationTransportMatrixComponent";
import { CrewActivityMobileViewContainer } from "./components/crewActivity/CrewActivityMobileViewContainer";
function App() {
  const { isNetworkError, setIsNetworkError } = useNetwork();
  if (isNetworkError) {
    return (
      <PageNotAccessibleComponent onRetry={() => setIsNetworkError(false)} />
    );
  }
  const isAuthorized =
    sessionStorage.getItem("session_userId") === "" ||
    sessionStorage.getItem("session_userId") === null
      ? false
      : true;

  return (
    <>
      {isAuthorized === true ? (
        <AuthorisedLayout>
          {/* <Route path="*" component={DashboardComponent} />
          <Route path="/" component={DashboardComponent} /> */}
          <Route path="/dashboard" component={DashboardComponent} />
          <Route path="/airport" component={AirportComponent} />
          <Route path="/tracking" component={TrackingComponent} />
          <Route path="/hotels" component={HotelsComponent} />
          <Route
            path="/service-providers"
            component={ServiceProviderComponent}
          />
          <Route path="/reservations" component={ReservationsComponent} />
          <Route path="/dispatch" component={DispatchComponent} />
          <Route path="/crew-member" component={CrewMembersComponent} />
          <Route path="/user" component={UserComponent} />
          <Route path="/rating" component={RatingComponent} />
          <Route exact path="/feedback" component={FeedbackComponent} />
          <Route
            exact
            path="/feedback/comment"
            component={FeedbackCommentComponent}
          />
          <Route path="/notification" component={NotificationComponent} />
          <Route path="/reimburseTransport" component={ReimburseTransport} />
          <Route path="/billing" component={UnApprovedApprovedRidesComponent} />
          <Route path="/transportDepartment" component={TransportComponent} />
          <Route path="/invoice" component={InvoiceComponent} />
          <Route
            path="/scheduleDashboard"
            component={ScheduleDashBoardComponent}
          />
          <Route
            path="/config/hotel-transfer-contract"
            component={HotelTransferContractComponent}
          />
          <Route
            path="/config/transporthotel"
            component={TransportHotelConfigurationComponent}
          />
          <Route path="/config/email" component={EmailConfigurationComponent} />
          <Route path="/report/cancel" component={CancelHotelComponent} />
          <Route path="/report/stay" component={StayHotelComponent} />
          <Route path="/hotelbooking" component={HotelBookingComponent} />
          <Route
            path="/config/airport-transfer"
            component={CrewTypeTransportConfigurationComponent}
          />
          <Route
            path="/config/booking/hotelpriority"
            component={HotelBookingPriority}
          />
          <Route
            path="/report/geofence"
            component={AirportGeofenceReportComponent}
          />
          <Route
            path="/report/activity-rawdata"
            component={ActivityRawDataComponent}
          />
          <Route path="/crew-address" component={CrewAddressComponent} />
          <Route
            exact
            path="/crew-activity"
            component={CrewActivityComponent}
          />
          <Route
            path="/nonfly-activity-location"
            component={NonFlyActivityLocationComponent}
          />
          <Route
            path="/nonfly-transport-matrix"
            component={NonFlyTransportMatrixComponent}
          />
          <Route path="/activity-code" component={CrewActivityCodeComponent} />
          <Route
            path="/config/duty-location-transfer"
            component={ActivityDutyLocationTransferComponent}
          />
          <Route
            path="/config/transport-matrix"
            component={AirportHotelLocationTransportMatrixComponent}
          />
          <Route
            exact
            path="/crew-activity-mobile"
            component={CrewActivityMobileViewContainer}
          />
        </AuthorisedLayout>
      ) : (
        <Layout>
          <Route exact path="/" component={LoginComponent} />
          <Route path="/login" component={LoginComponent} />
          <Route path="/forgot-password" component={ForgotPasswordComponent} />
          <Route path="/register" component={RegisterComponent} />
          <Route path="/reset-password" component={ResetPasswordComponent} />
        </Layout>
      )}
    </>
  );
}
export default App;
